import * as React from "react";
import { Row, Col, Form, InputGroup, Button, Modal } from "react-bootstrap";
import { SearchIcon } from "../../ui/icons";
import CascadeGroupTreeView from "../../CascadeGroupTreeView";
import useSelectGroup from "./useSelectGroup";
import { ISelectGroupState } from "../../../common/types/alertsTypes";
const SelectGroup = ({
  // isEmergencyAlert,
  onNextTab,
  onClose,
  onCreateAlert,
  selectGroupState,
  setSelectGroupState,
  isSelectGroupFieldEmpty,
  isEditAlert,
  isQuickAlert,
  isEditQuickAlert,
  alertMessage,
  alertHeading,
}: {
  // isEmergencyAlert: boolean,
  onNextTab: () => void;
  onCreateAlert: () => void;
  onClose: () => void;
  isSelectGroupFieldEmpty: (isAnyFieldEmpty: boolean) => void;
  selectGroupState: ISelectGroupState;
  setSelectGroupState: (state: ISelectGroupState) => void;
  isEditAlert: boolean;
  isQuickAlert: boolean;
  isEditQuickAlert: boolean;
  alertMessage: string;
  alertHeading: string;
}) => {
  const {
    groupSearchQuery,
    handleGroupInputChange,
    nodesToDisplay,
    handleDataFromTreeView,
    handleNextButtonClick,
    isAnyFieldEmpty,
    expandedValues,
    setExpandedValues
  } = useSelectGroup(
    // isEmergencyAlert,
    onNextTab,
    onCreateAlert,
    selectGroupState,
    setSelectGroupState,
    isSelectGroupFieldEmpty
  );
  return (
    <div className="select-group-container">
      <Row>
        <Col sm={5}>
          <div className="send-alerts-group-content">
            <label className="heading">Send Alerts to Group(s)</label>
            <div className="alerts-search-and-tree">
              <div className="alert-search-input">
                <InputGroup>
                  <Form.Control
                    placeholder="Search"
                    aria-label="Search"
                    aria-describedby="alert-search-input"
                    value={groupSearchQuery}
                    onChange={handleGroupInputChange}
                  />
                  <InputGroup.Text id="alert-search-input">
                    <SearchIcon />
                  </InputGroup.Text>
                </InputGroup>
              </div>
              <div className="alert-checkbox">
                <div className="select-all-checkbox">
                  <CascadeGroupTreeView
                    nodes={nodesToDisplay}
                    expandedValues={expandedValues}
                    setExpandedValues={setExpandedValues}
                    onDataFromTreeView={handleDataFromTreeView}
                    selectGroupState={selectGroupState}
                    setSelectGroupState={setSelectGroupState}
                    isSelectAllEnabled={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col sm={1}>
          <div className="line"></div>
        </Col>
        <Col sm={6}>
          <div className="alert-select-group">
            <div className="alert-select-bg">
              <div className="alert-select-group-text-heading">
                {alertHeading !== "" ? alertHeading : null}
              </div>
              <div className="alert-select-group-text">{alertMessage}</div>
            </div>
          </div>
          {!isQuickAlert && !isEditQuickAlert && (
            <div className="alert-select-group-label">
              Your alert will be sent now.
            </div>
          )}
        </Col>
      </Row>
      <div>
        <Modal.Footer>
          <Button className="btn-cancel" onClick={onClose}>
            Cancel
          </Button>
          <Button
            className="btn-style"
            onClick={handleNextButtonClick}
            disabled={isAnyFieldEmpty}
          >
            {
              // isEmergencyAlert ?
              (isEditAlert || isEditQuickAlert) ? "Edit" : "Create"
              // : "Next"
            }
          </Button>
        </Modal.Footer>
      </div>
    </div>
  );
};

export default SelectGroup;
